import nodeService from '@/services/nodejs'
import cakeService from '@/services/cakephp'
import janooService from '@/services/janoo/index'
import operacaoStore from '@/views/Operacao/store'
import { hasModule } from '../../../store/utils/users'
import { fetchNPSReport } from './nps-report'

const daysWithoutCache = process.env.VUE_APP_DAYS_WITHOUT_CACHE
const maxParallelFetchRequests = process.env.VUE_APP_MAX_PARALLEL_FETCH
const maxLocaStorageSpace = process.env.VUE_APP_MAX_LOCALSTORAGE_SPACE
const billsMemBuffer = []
let storageUsedSpace = 0
let storageUsedSpaceInterval = 0
let newRequestsCount = 1
let doneRequestsCount = 0
let waitingRequestsCount = 0
let monitoringStorage = false
// Cada fetchBillItems zera a lista; respostas de uma carga anterior que chegam
// depois disso são descartadas, senão sobrescrevem dados mais novos.
let fetchGeneration = 0
const MAX_FETCH_ATTEMPTS = 3

/**
 *
 * @param {} state
 * @param {*} params
 */
const fetchBillItems = async (state, params) => {
  storageUsedSpace = 1
  storageUsedSpaceInterval = 0
  const generation = ++fetchGeneration
  resetBillsState(state)
  state.commit('SET_FETCHBILLS_IN_PROGRESS', true)
  var service = {}

  if (hasModule('enable_bookings_report')) {
    //Loading from Janoo?
    if (params.useFakeData) {
      concurrentPromise(state, janooService, params, 1, undefined, generation)
      return
    } else {
      service = nodeService
    }
  } else {
    service = cakeService
  }

  //create bills requests
  let requestArray = fillRequestArray(
    params.startDate,
    params.endDate,
    params.daysInternval || 1,
    params.operation_request
  )
  state.commit(
    'SET_REQUEST_ARRAY_STATUS',
    new Array(requestArray.length).fill('new')
  )
  requestArray.forEach((item, idx) => {
    var newParams = {
      startDate: item.start,
      endDate: item.end,
      useFakeData: params.useFakeData,
      operation_request: params.operation_request,
    }
    concurrentPromise(
      state,
      service,
      newParams,
      idx,
      maxParallelFetchRequests,
      generation
    )
  })
}

async function concurrentPromise(
  state,
  service,
  params,
  responseIndex,
  maxParallelRequest,
  generation,
  attempt = 1
) {
  if (!maxParallelRequest) {
    maxParallelRequest = 6
  }

  if (generation !== fetchGeneration) return

  if (params.useFakeData) {
    // let response = service.getBillItems(params)
    // formatArrayBillItems(state, response.data.data, response.data.bills);
  } else {
    doneRequestsCount = state.state.requestArrayStatus.filter(
      (resp) => resp == 'done'
    ).length
    waitingRequestsCount = state.state.requestArrayStatus.filter(
      (resp) => resp == '...loading'
    ).length

    //if all request done
    if (doneRequestsCount == state.state.requestArrayStatus.length) {
      return
    }

    //if current request is done
    if (state.state.requestArrayStatus[responseIndex] === 'done') {
      return
    }

    if (waitingRequestsCount >= maxParallelRequest) {
      setTimeout(
        () =>
          concurrentPromise(
            state,
            service,
            params,
            responseIndex,
            maxParallelRequest,
            generation,
            attempt
          ),
        responseIndex * 10
      )
      return
    }

    state.commit('SET_INDEX_VALUE_REQUEST_ARRAY_STATUS', {
      index: responseIndex,
      value: '...loading',
    })

    let transformedItems = []

    service
      .getBillItems(params)
      .then((response) => {
        if (generation !== fetchGeneration) return
        if (
          (responseIndex,
          state.state.requestArrayStatus[responseIndex] != 'done')
        ) {
          state.commit('SET_INDEX_VALUE_REQUEST_ARRAY_STATUS', {
            index: responseIndex,
            value: 'done',
          })
          newRequestsCount = state.state.requestArrayStatus.filter(
            (resp) => resp == 'new'
          ).length
          doneRequestsCount = state.state.requestArrayStatus.filter(
            (resp) => resp == 'done'
          ).length

          if (undefined != response.data[0]) {
            transformedItems = [...transformedItems, ...response.data]
          }

          //INÍCIO: CÓDIGO QUE DEVE SER MOVIDO PARA O BACKEND
          var bookingPaidStatusArray =
            state.rootState.operacao.bookingPaidStatusArray

          transformedItems.forEach((e) => {
            operacaoStore.actions.updateStatus(state, e, false)
          })

          //FIM: CÓDIGO QUE DEVE SER MOVIDO PARA O BACKEND

          state.commit('PUSH_TO_TRANSFORMED_ITEMS', transformedItems)
          billsMemBuffer.push(transformedItems)
        }

        if (newRequestsCount == 0) {
          state.commit('SET_FETCHBILLS_IN_PROGRESS', false)
          clearTimeout(storageUsedSpaceInterval)
          storageUsedSpaceInterval = 0
        }
      })
      .catch((error) => {
        if (generation !== fetchGeneration) return
        const context = {
          startDate: params.startDate,
          endDate: params.endDate,
          attempt,
          error,
        }

        if (attempt >= MAX_FETCH_ATTEMPTS) {
          // Desiste do período: marca como concluído para a tela sair do
          // carregando e registra a falha para ela avisar que faltam reservas.
          console.error('getBillItems failed, giving up', context)
          state.commit('SET_INDEX_VALUE_REQUEST_ARRAY_STATUS', {
            index: responseIndex,
            value: 'done',
          })
          state.commit('PUSH_FETCH_BILLS_FAILURE', {
            startDate: params.startDate,
            endDate: params.endDate,
          })
          billsMemBuffer.push([])
          if (
            state.state.requestArrayStatus.every((status) => status === 'done')
          ) {
            state.commit('SET_FETCHBILLS_IN_PROGRESS', false)
          }
          return
        }

        console.error('getBillItems failed, retrying', context)
        // Backoff exponencial com jitter: não martela a API se ela caiu
        const delay = 1000 * 2 ** (attempt - 1) + Math.random() * 500
        setTimeout(
          () =>
            concurrentPromise(
              state,
              service,
              params,
              responseIndex,
              maxParallelRequest,
              generation,
              attempt + 1
            ),
          delay
        )
      })
  }
}

function removeBufferItem(state, idx) {
  let popped = state.state.billsBuffer[idx]
  state.commit('POP_BILLS_BUFFER', idx)
  return popped
}

const reportStoreCommit = (state, payload) => {
  state.commit(payload.mutation, payload.value)
}

function resetBillsState(state) {
  billsMemBuffer.length = 0
  state.commit('RESET_FETCHBILLS_IN_PROGRESS')
  state.commit('RESET_REQUEST_ARRAY_STATUS')
  state.commit('RESET_TRANSFORMED_ITEMS')
  state.commit('RESET_FETCH_BILLS_FAILURES')
  state.commit('RESET_BILLS_BUFFER')
  state.commit('RESET_TOTAL_LOCAL_PAID_BILL_ITEMS')
  state.commit('RESET_TOTAL_ONLINE_PAID_BILL_ITEMS')
  state.commit('RESET_TOTALS_PERSONS_COUNT')
}

/**
 * Creates and return an array of dates between startDate and endDate in blocks of dateStep value
 * @param {String} startDate   //initial date
 * @param {String} endDate     //final date.
 * @param {Number} dateStep    //number of days between dates in each object
 * @returns
 */
function fillRequestArray(startDate, endDate, dateStep, operation_request) {
  if (!dateStep || dateStep < 0) {
    dateStep = 1
  }

  let oneDayMilliseconds = 86400000
  const dateSubstringLength = 10
  let start = new Date(startDate + ' 12:00:00')
  let end = new Date(endDate + ' 12:00:00')
  let nextDay = new Date(start.getTime())
  let startAux = new Date(startDate + ' 12:00:00')

  start.setTime(start.getTime() - oneDayMilliseconds)
  startAux.setTime(startAux.getTime(), dateStep - 1, oneDayMilliseconds)
  let currentDateSubstring = startAux
    .toISOString()
    .substr(0, dateSubstringLength)

  let requestObj = null
  let requestArray = []
  let requestArraySize = (
    (end - start) /
    (1000 * 60 * 60 * 24 * dateStep)
  ).toFixed(0)

  while (startAux.getTime() < end.getTime()) {
    if (startAux.getTime() < end.getTime()) {
      currentDateSubstring = startAux
        .toISOString()
        .substr(0, dateSubstringLength)
      nextDay.setTime(start.getTime() + oneDayMilliseconds)

      requestObj = {
        start: nextDay.toISOString().substr(0, 10),
        end: startAux.toISOString().substr(0, 10),
      }

      start.setTime(startAux.getTime())
      requestArray.push(requestObj)
    }

    //last days in interval use 1 day step
    if (
      requestArraySize - requestArray.length <
      (daysWithoutCache / dateStep).toFixed(0)
    ) {
      dateStep = 1
    }
    startAux.setTime(startAux.getTime() + dateStep * oneDayMilliseconds)
  }

  nextDay.setTime(start.getTime() + oneDayMilliseconds)
  requestObj = {
    start: nextDay.toISOString().substr(0, 10),
    end: end.toISOString().substr(0, 10),
  }

  requestArray.push(requestObj)
  return requestArray
}

function clearReportCacheFlags() {
  sessionStorage.removeItem('SET_BAR_CHART_ARRECADACAO_save')
  sessionStorage.removeItem('SET_BAR_CHART_HORARIO_save')
  sessionStorage.removeItem('SET_BAR_CHART_PRODUTIVIDADE_save')
  sessionStorage.removeItem('SET_BAR_CHART_TAMANHO_save')
  sessionStorage.removeItem('SET_BAR_CHART_VISITANTES_save')
  sessionStorage.removeItem('SET_DOUGHNUT_CHART_ATRATIVO_save')
}
/**
 *
 * @param {} billItemsResponses
 * Merge together in one object the result from all requests made present
 * in @billItemsResponses
 */
function coalesceBillItems(billItemsResponses) {
  //merge input request results
  var billItemsTemp = {}
  var billsTemp = {}

  billItemsResponses.forEach((resp) => {
    if (typeof resp !== 'object') {
      return
    }
    var keysBillItems = Object.keys(resp.data)
    var valuesBillItems = Object.values(resp.data)

    keysBillItems.map(function (value, index) {
      billItemsTemp[value] = valuesBillItems[index]
    })

    var keysBills = Object.keys(resp.bills)
    var valuesBills = Object.values(resp.bills)

    keysBills.map(function (value, index) {
      billsTemp[value] = valuesBills[index]
    })
  })
  return { billItems: billItemsTemp, bills: billsTemp }
}

function getBillsMemBuffer() {
  return billsMemBuffer
}

function removeMemBufferItem(state, index) {
  let popped = billsMemBuffer[index]
  billsMemBuffer[index] = 0
  return popped
}

const generateNPSReport = async (state, payload) => {
  return await fetchNPSReport(payload)
}

export default {
  fetchBillItems,
  resetBillsState,
  removeBufferItem,
  reportStoreCommit,
  getBillsMemBuffer,
  removeMemBufferItem,
  clearReportCacheFlags,
  generateNPSReport,
}
